// Client-only module: maps article slugs to their hero images.
// Kept separate from articles.ts so the server (tsx) can import article
// data without hitting Vite-only image imports.
import imgMetaAds from "@assets/stock_images/meta-ads-budget.jpg";
import imgTikTok from "@assets/stock_images/tiktok-ecommerce.jpg";
import imgTracking from "@assets/stock_images/server-side-tracking.jpg";
import imgAI from "@assets/stock_images/ai-digital-marketing.jpg";
import imgKlaviyo from "@assets/stock_images/klaviyo-vs-mailchimp.jpg";
import imgFunnel from "@assets/stock_images/meta-ads-funnel.jpg";
import imgPinterest from "@assets/stock_images/pinterest-ads-ecommerce.jpg";
import imgGrowth from "@assets/stock_images/dtc-startup-scaleup.jpg";
import imgAgency from "@assets/stock_images/traditional-vs-modern-agency.jpg";
import imgDataBranding from "@assets/stock_images/data-driven-branding.jpg";
import imgCreativeHooks from "@assets/stock_images/creative-hooks-data.jpg";
import imgBrandIdentity from "@assets/stock_images/d2c-brand-identity.jpg";
import imgVisualStorytelling from "@assets/stock_images/visual-storytelling-ecommerce.jpg";
import imgDataVsOnderbuik from "@assets/stock_images/data-vs-onderbuik.jpg";
import imgD2CPerformance from "@assets/artPic_public_L_3495432_1774432518598.webp";
import imgGrowthBureau from "@assets/blok4_2_1774432518597.jpg";
import imgMetaVsGoogle from "@assets/JutkaenRiska_e6868ebf-e03b-43ce-a87c-9d7b4634bf4a_1774432518589.webp";
import imgClaudeAPI from "@assets/6710cb65b09ebb5f7d6f30aa_66c852f043460eba98fe3b50_claude-ai_1776685324118.jpeg";

export const articleImages: Record<string, string> = {
  "branding-is-geen-gevoel-maar-data": imgDataBranding,
  "creative-hooks-die-converteren": imgCreativeHooks,
  "d2c-merkidentiteit-bouwen-met-data": imgBrandIdentity,
  "visual-storytelling-d2c-ecommerce": imgVisualStorytelling,
  "data-vs-onderbuikgevoel-marketing": imgDataVsOnderbuik,
  "meta-ads-budget-verkeerd-ingezet": imgMetaAds,
  "tiktok-ads-ecommerce-omzet": imgTikTok,
  "server-side-tracking-data-grip": imgTracking,
  "ai-speelveld-digital-marketing": imgAI,
  "klaviyo-vs-mailchimp-webshop": imgKlaviyo,
  "ideale-meta-ads-funnel-d2c": imgFunnel,
  "pinterest-ads-onderschat-kanaal": imgPinterest,
  "startup-scaleup-groeifasen-d2c": imgGrowth,
  "traditioneel-bureau-model-werkt-niet-d2c": imgAgency,
  "wat-is-d2c-performance-marketing": imgD2CPerformance,
  "hoe-werkt-growth-marketing-bureau": imgGrowthBureau,
  "meta-ads-vs-google-ads-d2c": imgMetaVsGoogle,
  "claude-api-marketingstack-d2c": imgClaudeAPI,
  "tiktok-ads-uitbesteden": imgTikTok,
  "wrkt-signal-competitive-ad-intelligence": imgAI,
  "beste-ai-bureaus-d2c-ecommerce": imgAgency,
  "ai-ecommerce-marketing-bureau-kiezen": imgAI,
  "social-ads-uitbesteden": imgCreativeHooks,
};
